import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export interface ArticleCtaProps {
  /** Button label (alternative to the inline `[text]` form). */
  text?: string
  /** Optional region slug to pre-filter the search (e.g. "sumava"). */
  region?: string
  /** Optional label id to pre-filter the search. */
  label?: string
  children?: ReactNode
}

/**
 * Call-to-action button linking to the offers listing, embedded in an article
 * via `::cta{text="Zobrazit nabídky" region="sumava"}` (or inline
 * `:cta[Zobrazit nabídky]{region="sumava"}`). Optionally pre-filters the search.
 */
export function ArticleCta({ text, region, label, children }: ArticleCtaProps) {
  const content = (text && text.length > 0 && text) || children || 'Zobrazit nabídky'
  const labelId = label ? Number(label) : undefined

  return (
    <div className="not-prose my-6 flex">
      <Button asChild variant="red" size="lg">
        <Link
          to="/ubytovani/hledat"
          search={(prev) => ({
            ...prev,
            ...(region ? { region } : {}),
            ...(labelId !== undefined && !Number.isNaN(labelId) ? { labelId } : {}),
          })}
        >
          {content}
        </Link>
      </Button>
    </div>
  )
}
